<template>
  <div class="edit_main">
    <div class="fx_1">
      <Form ref="editModel" :model="editModel" :rules="ruleValidate" :label-width="140">
        <FormItem label="查询标题（唯一）" prop="queryTitle">
          <Input class="w-250" v-model="editModel.queryTitle"></Input>
        </FormItem>
        <FormItem label="数据库类型" prop="dataBaseType">
          <Select class="w-250" v-model="editModel.dataBaseType" clearable>
            <Option
              v-for="(item, index) in dataBaseTypeSelect"
              :value="item.value"
              :key="index"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="数据库连接字符串" prop="dataBaseConnection">
          <Input v-model="editModel.dataBaseConnection" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>

        <FormItem label="查询语句" prop="querySql">
          <Input v-model="editModel.querySql" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>

        <FormItem label="描述信息" prop="description">
          <Input v-model="editModel.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
      <h3 class="mb-4">
        字段别名设置
        <span style="color:red">（注：字段别名必须和查询语句返回的字段一一对应）</span>
        <a class="ml-3" @click="addItem">添加字段</a>
      </h3>

      <Form ref="additemModel" :model="additemModel" :label-width="140" inline>
        <div class="dictionaryItems-panel">
          <div v-for="(item,index) in fieldAliasArr" :key="index">
            <FormItem label="字段">
              <Input class="w-180" v-model="item.key"></Input>
            </FormItem>
            <FormItem label="字段中文名">
              <Input class="w-180" v-model="item.title"></Input>
            </FormItem>
            <a class="ml-5" @click="deleteItem(index)">删除</a>
          </div>
        </div>
      </Form>
    </div>

    <div class="edit_btn_group">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: function () {
    return {
      organParentName: "",
      editModel: {
        id: "",
        queryTitle: "",
        dataBaseType: "",
        dataBaseConnection: "",
        querySql: "",
        description: "",
        fieldAlias: "",
        createUser: "",
      },
      additemModel:{},
      fieldAliasArr: [],
      dataBaseTypeSelect: [],
      ruleValidate: {
        queryTitle: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        dataBaseType: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        dataBaseConnection: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        querySql: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  activated: function () {
    this.dataBaseTypeSelect = this.$common.getJsonData("dataBaseType");
    this.initData()
  },

  methods: {
    initData(){
      this.$api.get("customquery/getById", {id:this.$route.query.id}).then((rsp) => {
        if (rsp != false) {
          this.editModel=rsp.data
          this.fieldAliasArr = JSON.parse(this.editModel.fieldAlias);
        }
      });
    },
    returnBack: function () {
      this.initData()
      this.$router.push({ path: "customquery" });
    },

    addItem() {
      var temp = { key: "", title: "" };
      this.fieldAliasArr.push(temp);
    },

    deleteItem(index) {
      this.fieldAliasArr.splice(index, 1);
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (this.fieldAliasArr.length < 1) {
            this.$Message.warning("字段别名设置不能为空");
            return false;
          }
          this.editModel.fieldAlias = JSON.stringify(this.fieldAliasArr);
          this.$api.post("customquery/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.returnBack();
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
</style>